import { isNil, each, isString } from './util';
import { getOffScreenContext } from './offscreen';
/**
 * è·åææ¬çé«åº¦
 * @param text ææ¬
 * @param fontSize å­ä½å¤§å°
 * @param lineHeight è¡é«ï¼å¯ä»¥ä¸ºç©º
 */
export function getTextHeight(text, fontSize, lineHeight) {
    var lineCount = 1;
    if (isString(text)) {
        lineCount = text.split('\n').length;
    }
    if (lineCount > 1) {
        var spaceingY = getLineSpaceing(fontSize, lineHeight);
        return fontSize * lineCount + spaceingY * (lineCount - 1);
    }
    return fontSize;
}
/**
 * è·åè¡é´è·å¦æææ¬å¤è¡ï¼éè¦è·åææ¬é´è·
 * @param fontSize å­ä½å¤§å°
 * @param lineHeight è¡é«
 */
export function getLineSpaceing(fontSize, lineHeight) {
    return lineHeight ? lineHeight - fontSize : fontSize * 0.14;
}
/**
 * å­ä½å®½åº¦
 * @param text ææ¬
 * @param font å­ä½
 */
export function getTextWidth(text, font) {
    var context = getOffScreenContext(); // è·åç¦»å±ç ctx è¿è¡è®¡ç®
    var width = 0;
    // null æè undefined æ¶ï¼å®½åº¦ä¸º 0
    if (isNil(text) || text === '') {
        return width;
    }
    context.save();
    context.font = font;
    if (isString(text) && text.includes('\n')) {
        var textArr = text.split('\n');
        each(textArr, function (subText) {
            var measureWidth = context.measureText(subText).width;
            if (width < measureWidth) {
                width = measureWidth;
            }
        });
    }
    else {
        width = context.measureText(text).width;
    }
    context.restore();
    return width;
}
export function assembleFont(attrs) {
    var fontSize = attrs.fontSize, fontFamily = attrs.fontFamily, fontWeight = attrs.fontWeight, fontStyle = attrs.fontStyle, fontVariant = attrs.fontVariant;
    return [fontStyle, fontVariant, fontWeight, fontSize + "px", fontFamily].join(' ').trim();
}
//# sourceMappingURL=text.js.map